var _defs, _ellipse, _path, _path2, _ellipse2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.4 2.4 61.2 61.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sk",
    cx: "40%",
    cy: "38%",
    r: "72%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcb88e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86562e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fl",
    cx: "45%",
    cy: "40%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcd2c0"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 60,
    rx: 28,
    ry: 3.6,
    fill: "#000",
    opacity: 0.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22 Q5 36 6 50 Q6 59 14 59.5 L50 59.5 Q58 59 58 50 Q59 36 49 22Z",
    fill: "url(#sk)",
    stroke: "#5e3a1c",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 55 Q14 51 18 56 M54 55 Q50 51 46 56 M28 59 Q32 55 36 59",
    stroke: "#6e4422",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 20,
    rx: 19,
    ry: 7,
    fill: "#6e4422"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21 Q16 9 32 7 Q48 9 50 21 Q42 19 32 19.5 Q22 19 14 21Z",
    fill: "url(#fl)",
    stroke: "#c9b48a",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20 Q32 30 52 20 L52 23 Q32 34 12 23Z",
    fill: "#c49a6c",
    stroke: "#5e3a1c",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14 L50 4",
    stroke: "#8f979e",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38 L38 38 L38 50 L26 50Z",
    fill: "#d8b04a",
    stroke: "#8a6a2a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.cec5965429aa658dc6638cd1c784bbd9.svg";
export { ForwardRef as ReactComponent };